import { Button, Card, Divider, Typography } from "antd"
import Layout from "modules/layout/dashboard"
import { useInvoiceId, useMemberId } from "pages/member"
import { useMember } from "pages/member/queries"
import { useInvoice } from "../../queries"
import { useNavigate } from "react-router-dom"
import InteracLogo from "assets/interac-logo.webp"
import styles from "./styles.module.scss"
import { Trans, useTranslation } from "react-i18next"
const { Main } = Layout
const { Title, Text } = Typography
const Payment: React.FC = () => {
  const { t } = useTranslation()
  const memberId = useMemberId()
  const member = useMember(memberId)
  const invoiceId = useInvoiceId()
  const invoice = useInvoice(memberId!, invoiceId!)
  const navigate = useNavigate()
  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          { title: "Factures", link: `/members/${member.data?.id}/invoices` },
          {
            title: invoice.data?.reference ?? invoice.data?.proforma_reference ?? "-",
            link: `/members/${member.data?.id}/invoices/${invoice.data?.id}`,
          },
          { title: t("invoice.payment") },
        ]}
        title={
          <Title level={3}>
            {t("invoice.text_1")} No:{" "}
            {invoice.data?.reference ?? invoice.data?.proforma_reference ?? "-"}
          </Title>
        }
      />
      <Card>
        <div className={styles.contentContainer}>
          <img src={InteracLogo} className={styles.interacImg} alt="Interac" />
          <Button type="primary" onClick={() => navigate("pay_invoice")}>
            {t("invoice.pay_my_invoice")}
          </Button>
        </div>
        <Text>{t("invoice.text_2")} :</Text>
        <ol type="a">
          <li>
            <Text>
              <Trans
                i18nKey={"invoice.text_3"}
                t={t}
                components={[
                  <Text strong style={{ marginRight: 12 }}>
                    value
                  </Text>,
                ]}
              />
            </Text>
          </li>
          <li>
            <Text>
              <Trans
                i18nKey={"invoice.text_4"}
                t={t}
                components={[<Text strong>email payment recipient</Text>]}
              />
            </Text>
          </li>
        </ol>
        <Text>{t("invoice.text_5", { lettersCase: "none" })} :</Text>
        <ol type="a" start={3}>
          <li>
            <Text>
              <Trans
                i18nKey={"invoice.text_6"}
                t={t}
                components={[<Text strong>name</Text>]}
                autoCapitalize={false}
              />
            </Text>
          </li>
          <li>
            <Text>{t("invoice.text_7")}</Text>
          </li>
        </ol>
        <Divider />
        <Text>{t("client_specific.team", { lettersCase: "none" })}</Text>
      </Card>
    </>
  )
}

export default Payment
